export default __webpack_public_path__ + "static/media/018-lemon slice.170feb54.svg";